import { Box, Checkbox, ToggleButton as MuiToggleButton, Radio, Typography } from '@mui/material';

import { SvgIconWrapper } from 'components/SvgIconWrapper';
import { isEmpty } from 'lodash-es';
import type { FC } from 'react';
import {
  ToggleButtonDescriptionStyle,
  ToggleButtonLabelStyle,
  ToggleButtonStyle,
  ToggleButtonWrapperStyle,
} from './ToggleButton.styles';
import type { IToggleButton, IToggleButtonAdornment } from './ToggleButton.types';

/**
 * Helper for rendering the adorment if provided
 *
 * Checks the type and determines what to render
 *
 * @default <></>
 */
const renderAdornment = (endAdornment?: IToggleButtonAdornment) => {
  if (!isEmpty(endAdornment)) {
    switch (endAdornment.type) {
      case 'icon':
        return <SvgIconWrapper src={endAdornment.src} />;

      case 'image':
        return <img src={endAdornment.src} width={50} height={48} alt={endAdornment.alt ?? ''} />;

      default:
        return <></>;
    }
  }

  return <></>;
};

const ToggleButton: FC<IToggleButton> = ({
  label,
  value,
  description,
  fillType,
  active,
  endAdornment,
  inputVariant,
  ...rest
}) => {
  const isActive = Boolean(active);

  return (
    <MuiToggleButton
      {...rest}
      selected={isActive}
      value={value}
      sx={{
        gridColumn: fillType === 'full' ? 'span 2' : 'span 1',
        ...ToggleButtonStyle,
      }}
    >
      <Box sx={ToggleButtonWrapperStyle}>
        {inputVariant === 'radio' ? (
          <Radio
            inputProps={{
              readOnly: rest.disabled,
            }}
            checked={isActive}
            disableRipple
            disableFocusRipple
            disableTouchRipple
          />
        ) : (
          <Checkbox
            inputProps={{
              readOnly: rest.disabled,
            }}
            checked={isActive}
            disableRipple
            disableFocusRipple
            disableTouchRipple
          />
        )}

        <Typography variant="h3" sx={ToggleButtonLabelStyle}>
          {label}
        </Typography>

        {renderAdornment(endAdornment)}
      </Box>

      {description && <Typography sx={ToggleButtonDescriptionStyle}>{description}</Typography>}
    </MuiToggleButton>
  );
};

export default ToggleButton;
